import { ProductTileDataContext } from "../../utils/productTile/ProductTileProvider.js";
import { useContext } from "react";
const useProductTileData = () => {
  const context = useContext(ProductTileDataContext);
  if (!context) {
    throw new Error(
      "`useProductTileData` must be used within a `ProductTileDataContext.Provider`"
    );
  }
  return context;
};
export {
  useProductTileData
};
